
@let state = wrapper().state();
@if (state === 'loading') {
    <div class="row">
        <div class="col-xs-12">
            <p i18n>Loading...</p>
        </div>
    </div>
}
@if (state === 'error') {
    @let error = wrapper().error();
    <div class="row error">
        <div class="col-xs-12">
            @if (error?.message) {
                <p class="error-message">{{ error?.message }}</p>
            } @else {
                <p class="error-message" i18n>Error loading</p>
            }

            @if (isErrorWithDetails(error)) {
                <pre class="error-details">{{ error.details }}</pre>
            }
        </div>
    </div>
}
@if (state === 'success') {
    @if (wrapper().value()) {
        <ng-container *ngTemplateOutlet="content"></ng-container>
    }
}

<ng-template #content>
    <ng-content></ng-content>
</ng-template>